"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const styles_1 = __importDefault(require("../../styles/styles"));
const select_1 = __importDefault(require("../select/select"));
const themes_1 = __importDefault(require("../../styles/themes"));
const FieldErrorMessageComponent_1 = __importDefault(require("../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const utils_1 = require("../../utils/utils");
const sectionHeader_1 = __importDefault(require("../headers/sectionHeader"));
const auditConstants_1 = require("../auditComponent/auditConstants");
const ticketConstants_1 = require("../../features/ticket/ticketConstants");
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const officersSlice_1 = require("../../features/officer/officersSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const ticketUtils_1 = require("./ticketUtils");
const generateFormFields = (key, choices, values, handleChange) => {
    const currentValue = values[key];
    const title = key === 'supplementary_subject' ? 'Custom subject' : utils_1.formatTitle(key);
    const shortTextNumberOfLines = 1;
    const longTextNumberOfLines = 4;
    return (react_1.default.createElement(react_native_1.View, { key: key, style: [styles_1.default.marginTen] },
        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.fontSizeText] }, title),
        choices ? (react_1.default.createElement(select_1.default, { value: currentValue, setValue: () => { }, choices: choices, setValueFormik: handleChange(key), style: styles_1.default.select, searchable: key === 'subject' })) : (react_1.default.createElement(react_native_paper_1.TextInput, { multiline: true, numberOfLines: key === 'description' ? longTextNumberOfLines : shortTextNumberOfLines, label: title, onChangeText: handleChange(key), value: currentValue, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput })),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignItemsCenter] },
            react_1.default.createElement(formik_1.ErrorMessage, { name: key, component: FieldErrorMessageComponent_1.default }))));
};
const TicketFormFields = ({ values, handleChange, fields }) => {
    const dispatch = useAppDispatch_1.default();
    const isDesktop = useWebDesktopDesign_1.default();
    const { officer, officers } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
        officers: state.officers.officers.data,
    }));
    const customerDataSegment = [];
    const ticketSummarySegment = [];
    const ticketStatusSegment = [];
    const ticketAssignedOfficerSegment = [];
    const sectionStyle = [
        isDesktop ? styles_1.default.flexDirectionRow : styles_1.default.flexDirectionColumn,
        styles_1.default.flexWrap,
    ];
    react_1.useEffect(() => {
        dispatch(officersSlice_1.getOfficers({ officer_type: officer.officer_type }));
    }, []);
    const onSearch = (input) => ticketUtils_1.searchOfficers(dispatch, input);
    const officerChoices = ticketUtils_1.generateOfficerChoices(officers);
    fields.forEach(([key, item]) => {
        // Generate the form field based on the key and its associated choices
        let field;
        if (key === 'assigned_officer') {
            field = (react_1.default.createElement(select_1.default, { value: values[key], setValue: () => { }, setValueFormik: handleChange(key), choices: officerChoices, style: styles_1.default.select, searchable: true, onSearch: onSearch }));
        }
        else {
            field = generateFormFields(key, item.choices, values, handleChange);
        }
        // Categorize the field based on the key and add it to the appropriate segment.
        // This was done to categorize related ticket fields into segments for better visual and user experience.
        if (ticketConstants_1.TICKET_SUMMARY_KEYS.includes(key)) {
            customerDataSegment.push(field);
        }
        else if (ticketConstants_1.TICKET_DESCRIPTION_KEYS.includes(key)) {
            ticketSummarySegment.push(field);
        }
        else if (ticketConstants_1.TICKET_ASSIGNED_OFFICER_KEYS.includes(key)) {
            ticketAssignedOfficerSegment.push(field);
        }
        else {
            ticketStatusSegment.push(react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne }, field));
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(sectionHeader_1.default, { section: `Ticket Summary ` }),
            react_1.default.createElement(react_native_1.View, { style: sectionStyle }, customerDataSegment)),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(sectionHeader_1.default, { section: `Ticket Details ` }),
            react_1.default.createElement(react_native_1.View, { style: sectionStyle },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne }, ticketSummarySegment[0]),
                Number(values.subject) === auditConstants_1.OTHER_TAG_CHOICE && (react_1.default.createElement(react_native_1.View, { style: { marginTop: 2 } }, ticketSummarySegment[1]))),
            react_1.default.createElement(react_native_1.View, null, ticketSummarySegment[2])),
        ticketStatusSegment.length > 0 && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(sectionHeader_1.default, { section: `Ticket Status ` }),
            react_1.default.createElement(react_native_1.View, { style: sectionStyle }, ticketStatusSegment))),
        ticketAssignedOfficerSegment.length > 0 && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(sectionHeader_1.default, { section: `Assign Officer ` }),
            react_1.default.createElement(react_native_1.View, { style: sectionStyle }, ticketAssignedOfficerSegment)))));
};
exports.default = TicketFormFields;
